<template>
  <input
    :class="rootClassName"
    v-model="lazyValue"
    v-on="listeners"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  name: 'Input',

  props: {
    value: {
      type: [String, Number],
    },

    variant: {
      type: String,
      default: 'outlined',
      validator: (variant) => ['outlined', 'inline'].includes(variant),
    },

    size: {
      type: String,
      validator: (variant) => ['small'].includes(variant),
    },

    fullWidth: {type: Boolean},

    minWidth: {type: Boolean},

    centered: {type: Boolean},

    placeholder: {type: String}
  },

  watch: {
    value(val) {
      this.lazyValue = val;
    },
  },

  data() {
    return {
      lazyValue: this.value,
    };
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (e) => this.$emit('input', e.target.value),
        change: (e) => this.$emit('change', e.target.value),
      };
    },

    proxy: {
      get() {
        return this.lazyValue;
      },

      set(value) {
        this.lazyValue = value;
        this.$emit('input', value);
      },
    },

    rootClassName() {
      return [
        'Input',
        {
          'variant-outlined': this.variant === 'outlined',
          'variant-inline': this.variant === 'inline',
          'size-small': this.size === 'small',
          fullWidth: this.fullWidth,
          minWidth: this.minWidth,
          centered: this.centered,
        },
      ];
    },
  },
};
</script>

<style scoped>
.Input {
  min-height: 40px;

  @apply outline-none
    p-2
		font-medium
		text-base
    text-secondary;
}

.Input:focus {
  @apply border-primary;
}

/* https://www.w3schools.com/howto/howto_css_hide_arrow_number.asp */
.Input::-webkit-outer-spin-button,
.Input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.Input[type='number'] {
  -moz-appearance: textfield;
}

.fullWidth {
  width: 100%;
}

/* TODO: this might need an as-wide-as-text implementation */
.minWidth {
  width: 80px;
}

.centered {
  text-align: center;
}

.variant-outlined {
  @apply border
		border-solid
		border-dull
    rounded;
}

.variant-inline {
  @apply border-solid
    border-b
    border-dull;
}

.size-small {
  width: 0;
  min-width: 64px;
  min-height: 24px;

  @apply text-sm;
}

</style>
